import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const segmentLanguageStep = defineStepConfig({
  type: "segment_language",
  name: "Segment Language",
  description:
    "Parse multilingual text into segments labeled with language and character offsets.",
  category: "AI & Agents",

  inputSchema: z.object({
    text: z.string().min(1).describe("The text to segment by language."),
  }),

  outputSchema: z.object({
    segments: z.array(
      z.object({
        text: z.string(),
        language: z.string(),
        languageName: z.string(),
        startOffset: z.number(),
        endOffset: z.number(),
        confidence: z.number(),
      }),
    ),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "3 minutes",
    retry: {
      maximumAttempts: 2,
    },
  },
});
